export interface OutlookAddinEnv {
  apiBaseUrl: string;
  supabase: {
    url: string;
    anonKey: string;
  };
  defaultMeetingDurationMinutes: number;
  defaultSlotMinutes: number;
  daysVisible: number;
}

const FALLBACK_API = "https://api.heyea.ai";
const FALLBACK_SUPABASE_URL = "https://vcfhozzvwxqbwofbzcar.supabase.co";
const FALLBACK_SUPABASE_KEY = "sb_publishable_C0g2GOTKudxjoIuxGKOReg_uDunBR-o";

const resolve = (value: string | undefined, fallback: string): string => {
  if (value && value.length > 0) {
    return value;
  }
  return fallback;
};

const nodeEnv = typeof process !== "undefined" ? process.env : undefined;

export const environment: OutlookAddinEnv = {
  apiBaseUrl: resolve(nodeEnv?.HAI_API_URL, FALLBACK_API),
  supabase: {
    url: resolve(nodeEnv?.HAI_SUPABASE_URL, FALLBACK_SUPABASE_URL),
    anonKey: resolve(nodeEnv?.HAI_SUPABASE_ANON_KEY, FALLBACK_SUPABASE_KEY),
  },
  defaultMeetingDurationMinutes: 30,
  defaultSlotMinutes: 15,
  daysVisible: 5,
};
